import ManagerList from './ManagerList';

export default ManagerList;